
/*
    Display from an individual trip-on-time report record,
    with media query differences for screen widths

    If it's broken down by date, display that above each record
*/

import React from "react";
import Media from "react-media";

import DataItem from "../Components/DataItem";

/*
    route: "25",
    total: "4099",
    scheduledLate: "34",
    scheduledOnTimePercent: "99.17",
    runsLate: "90",
    runsOnTimePercent: "97.8",

    passBoarding: "15",
    passArriving: "24",
    passGettingOff: "31",
    passLeftBehind: "2",
    passDeparting: "12"
*/

const dateStyle={
    padding: "8px 8px 0"
};

export default class ReportTripOnTimeData extends React.Component {
    render() {

        const {data} = this.props;

        const hasDate = !!data.SchedDate;
        const style = hasDate ? dateStyle : {};

        return (
            <>
            <div style={style}>
                {
                    hasDate
                    ? <div style={{fontSize:"small"}}>{data.SchedDate}</div>
                    : null
                }
                <Media query="(max-width: 811px)">
                    <div className="data" style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 3fr 3fr 4fr 3fr 3fr",
                        gridGap: "4px",
                        padding: "8px 8px",
                        justifyItems: "flex-start",
                        alignItems: "center"
                    }}>
                        <div><DataItem val={data.ReportSubject} /></div>
                        <div>Total Departed: <DataItem val={data.Total} /></div>
                        <div>Sched Late: <DataItem val={data.SchedLate} /></div>
                        <div>S-OT%: <DataItem val={data.SchedPercentage} /></div>
                        <div>Departed Late: <DataItem val={data.RunLate} /></div>
                        <div>R-OT%: <DataItem val={data.RunPercentage} /></div>
                        <div>PASS</div>
                        <div>Boarding: <DataItem val={data.Passengers} /></div>
                        <div>Arriving: <DataItem val={data.Passoacount} /></div>
                        <div>Getting Off: <DataItem val={data.Passgocount} /></div>
                        <div>Left Behind: <DataItem val={data.Passlbcount} /></div>
                        <div>Departing: <DataItem val={data.Passodcount} /></div>
                    </div>
                </Media>
                <Media query="(min-width: 812px)">
                    <div className="data" style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 2fr 1fr 2fr 2fr 2fr 2fr 2fr",
                        gridGap: "4px",
                        padding: "8px 0",
                        justifyItems: "center",
                        alignItems: "center",
                        marginBottom: "6px"
                    }}>
                        <div><DataItem val={data.ReportSubject} /></div>
                        <div><DataItem val={data.Total} /></div>
                        <div><DataItem val={data.SchedLate} /></div>
                        <div><DataItem val={data.SchedPercentage} /></div>
                        <div><DataItem val={data.RunLate} /></div>
                        <div><DataItem val={data.RunPercentage} /></div>
                        <div></div>
                        <div><DataItem val={data.Passengers} /></div>
                        <div><DataItem val={data.Passoacount} /></div>
                        <div><DataItem val={data.Passgocount} /></div>
                        <div><DataItem val={data.Passlbcount} /></div>
                        <div><DataItem val={data.Passodcount} /></div>
                    </div>
                </Media>
            </div>
            </>
        );
    }
}